"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
function createGradient(color1, color2) {
    return `linear-gradient(135deg, ${color1}, ${color2})`;
}
// SETUP COLORS
const PRIMARY = {
    lighter: '#D5E0F4',
    light: '#81A3DD',
    main: '#1D3A6C',
    dark: '#132748',
    darker: '#0A1324',
};
const PRIMARY_DARK = {
    lighter: '#c3d3ef',
    light: '#b5c8eb',
    main: '#A3BBE6',
    dark: '#7282a1',
    darker: '#4f5b70',
};
const SECONDARY = {
    lighter: '#FFF8E0',
    light: '#FFDF7C',
    main: '#FFC905',
    dark: '#FFB100',
    darker: '#FF8C00',
};
const INFO = {
    lighter: '#DDF3FD',
    light: '#7DD3F6',
    main: '#1EB2F0',
    dark: '#0B74A0',
    darker: '#042F40',
};
const SUCCESS = {
    lighter: '#E2F7E5',
    light: '#92E29C',
    main: '#42CC54',
    dark: '#248631',
    darker: '#0F3614',
};
const WARNING = {
    lighter: '#FDF1DD',
    light: '#F6C97D',
    main: '#F0A21E',
    dark: '#A0680B',
    darker: '#402A04',
};
const ERROR = {
    lighter: '#FBE2DE',
    light: '#EF9284',
    main: '#E4422A',
    dark: '#972413',
    darker: '#3D0F08',
};
const GREY = {
    0: '#FFFFFF',
    100: '#f5f5f3',
    200: '#f1f1ef',
    300: '#dfdfdd',
    400: '#cacac8',
    500: '#9e9d9b',
    600: '#747472',
    700: '#525251',
    800: '#2e2e2d',
    900: '#20201f',
    500_8: (0, styles_1.alpha)('#9e9d9b', 0.08),
    500_12: (0, styles_1.alpha)('#9e9d9b', 0.12),
    500_16: (0, styles_1.alpha)('#9e9d9b', 0.16),
    500_24: (0, styles_1.alpha)('#9e9d9b', 0.24),
    500_32: (0, styles_1.alpha)('#9e9d9b', 0.32),
    500_48: (0, styles_1.alpha)('#9e9d9b', 0.48),
    500_56: (0, styles_1.alpha)('#9e9d9b', 0.56),
    500_80: (0, styles_1.alpha)('#9e9d9b', 0.8),
};
const GRADIENTS = {
    primary: createGradient(PRIMARY.main, '#79FAC5'),
    secondary: createGradient(SECONDARY.main, '#FFC1B2'),
    info: createGradient(INFO.light, INFO.dark),
    success: createGradient(SUCCESS.light, SUCCESS.dark),
    warning: createGradient(WARNING.light, WARNING.dark),
    error: createGradient(ERROR.light, ERROR.dark),
};
const CHART_COLORS = {
    violet: ['#6A4CFF', '#957DFF', '#BFAEFF', '#E1D8FF'],
    blue: ['#197BFF', '#4BAEFF', '#80D7FF', '#B8ECFF'],
    green: ['#16B578', '#40D8A0', '#80EFC8', '#BFF9DF'],
    yellow: ['#FFD200', '#FFE552', '#FFF48C', '#FFF8D6'],
    red: ['#FF4C33', '#FF745D', '#FFA08B', '#FFD8CB'],
    orange: ['#FF7300', '#FF9A40', '#FFBC80', '#FFDEC3'],
    pink: ['#FF4578', '#FF7C9E', '#FFADBF', '#FFE0EC'],
    teal: ['#00A37F', '#2FC8A6', '#66DEC5', '#A3F3E3'],
    cyan: ['#0098D4', '#33B7E2', '#66D4EF', '#B0E9F8'],
    purple: ['#7C3BFF', '#9E65FF', '#C495FF', '#E1C7FF'],
    brown: ['#6A2E1F', '#925741', '#B77A64', '#D9A98C'],
    lime: ['#A8E600', '#C1F33A', '#D7FC7D', '#EEFFC1'],
    mint: ['#78F5A4', '#9FFFC4', '#B9FFE0', '#D6FFF0'],
    peach: ['#FFA37D', '#FFB599', '#FFCCB4', '#FFDFD2'],
    charcoal: ['#2B3742', '#47525F', '#5F6B75', '#7F8E95'],
};
const COMMON = {
    common: { black: '#000', white: '#fff' },
    primary: { ...PRIMARY, contrastText: '#fff' },
    secondary: { ...SECONDARY, contrastText: GREY[800] },
    info: { ...INFO, contrastText: '#fff' },
    success: { ...SUCCESS, contrastText: GREY[800] },
    warning: { ...WARNING, contrastText: GREY[800] },
    error: { ...ERROR, contrastText: '#fff' },
    grey: GREY,
    gradients: GRADIENTS,
    chart: CHART_COLORS,
    divider: GREY[500_24],
    action: {
        hover: GREY[500_8],
        selected: GREY[500_16],
        disabled: GREY[500_80],
        disabledBackground: GREY[500_24],
        focus: GREY[500_24],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};
const palette = {
    light: {
        ...COMMON,
        mode: 'light',
        text: { primary: GREY[800], secondary: GREY[700], disabled: GREY[500] },
        background: { paper: '#fff', default: GREY[200], neutral: GREY[100], dark: '#161B24' },
        action: { active: GREY[600], ...COMMON.action },
    },
    dark: {
        ...COMMON,
        primary: PRIMARY_DARK,
        mode: 'dark',
        text: { primary: '#fff', secondary: GREY[500], disabled: GREY[600] },
        background: { paper: '#212936', default: '#191D2A', neutral: GREY[500_16], dark: '#161B24' },
        action: { active: GREY[500], ...COMMON.action },
    },
};
exports.default = palette;
